import { SessionCardResponse } from "../contracts/SessionCardResponse";
import { SessionCard } from "../models/SessionCard";
import { toOccurrenceSlot } from "./OccurrenceSlotMapper";

/** Maps the Session card from the API to the frontend model. */
export const toSessionCard = (response: SessionCardResponse): SessionCard => ({
  bookingId: response.bookingId,
  name: response.name,
  nextOccurrence: toOccurrenceSlot(response.nextOccurrence ?? null),
  place: response.place ?? null,
  rosterCount: response.rosterCount,
  isCancelled: response.isCancelled,
});
